import classnames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import React from 'react';

const CSS = require('./SearchLoading.less');

interface SearchLoadingProps {
  isLoading: boolean;
  isFullScreen: boolean;
}

function SearchLoading({ isLoading, isFullScreen }: SearchLoadingProps) {
  if (!isLoading) {
    return null;
  }
  return (
    <div
      className={classnames(CSS.LoadingContainer, {
        [CSS.LoadingFullScreen]: isFullScreen,
      })}
    >
      <LoadingDots />
    </div>
  );
}

export default SearchLoading;
